import type { LngLat } from '../../types/property-v2';

/**
 * 永続データから読み込んだ waypoints を安全化する。
 * 配列でない/有効点が無ければ undefined を返す(スキーマは optional)。
 */
export function sanitizeWaypoints(v: unknown): LngLat[] | undefined {
  if (!Array.isArray(v)) return undefined;
  const out: LngLat[] = [];
  for (const p of v) {
    if (
      p &&
      typeof p === 'object' &&
      Number.isFinite((p as { lng?: unknown }).lng) &&
      Number.isFinite((p as { lat?: unknown }).lat)
    ) {
      out.push({ lng: (p as LngLat).lng, lat: (p as LngLat).lat });
    }
  }
  return out.length ? out : undefined;
}
